export default __webpack_public_path__ + "static/media/arrow_right_gallery.1ce59396.svg";